import React, { ReactElement } from 'react';
import { Page } from 'b2b-apps/shop/app/components/App/Page';
import '../ProductPage/ProductPage/ProductPage.scss';

const Skeleton = (): ReactElement => (
  <div className="container">
    <Page className="Product cds-Skeleton-Wrapper--Pulse" title="">
      <div className="cds-Skeleton--TextMedium" />
      <section className="Product-MainSection row">
        <div className="ProductGallery-Wrapper col-md-6">
          <div className="cds-Skeleton--Thumb" />
        </div>

        <div className="ProductData-Wrapper col-md-6">
          <div className="ProductData">
            <div className="ProductData-Title cds-Skeleton--TextLong cds-Skeleton--TextH1" />

            <div className="PriceList row">
              <div className="ProductData-Price col-md-4 col-sm-12">
                <div className="cds-Skeleton--TextShort cds-Skeleton--TextH2" />
                <div className="cds-Skeleton--TextMedium" />
              </div>
            </div>

            <div className="ProductData-BulletPoints">
              <div className="cds-Skeleton--TextLong" />
              <div className="cds-Skeleton--TextLong" />
              <div className="cds-Skeleton--TextMedium" />
              <div className="cds-Skeleton--TextMedium" />
            </div>

            <table className="ProductData-Features cds-Table cds-Table--Features">
              <tbody>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextMedium" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextMedium" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="ProductData-ActionsWrapper">
            <div className="ProductData-Buy order-1 order-sm-0">
              <div className="cds-Skeleton--TextLong cds-Skeleton--TextH1" />
            </div>
          </div>
        </div>
      </section>
    </Page>
  </div>
);

export { Skeleton };
